/**
 * The cases constants module houses cases-specific configurations.
 *
 * @module routes.cases.constants
 */

angular.module('routes.cases.constants', [])
  .config([
    '$provide',
    function ($provide) {
      'use strict';

      // Define.
      var cases;

      // Set defaults.
      cases = {};

      /**
       * Defines cases constants.
       *
       * @attribute CASES
       * @type String
       * @readOnly
       */
      $provide.constant('CASES', cases);
    }
  ]);
